import { verifyOTP, requestOTP, getNumbers } from '../Authentication.repo'
import { SMS_PROVIDER } from '../../../Constants'

const defaultState = {
  otp: '',
  valid: null,
  resentOTP: '',
  token: ''
}

const getters = {
  otp: (state) => state.otp,
  valid: (state) => state.valid,
  resentOTP: (state) => state.resentOTP,
  token: (state) => state.token
}

const actions = {
  clearOtpInput: ({ commit }, otp) => {
    if (otp.length > 0) {
      commit('clearOtpInput')
    }
  },
  verifyOtp: async ({ commit }, body) => {
    let response
    if (body.otp.length === 4) {
      body.otp = Number(body.otp)
      response = await verifyOTP(body).catch((error) => {
        commit('setValid', false)
        console.error(error)
      })
    } else {
      commit('setValid', false)
    }

    if (response) {
      commit('setToken', response.token)
    }
  },
  resetOtpValidity ({ commit }) {
    commit('setValid', null)
  },
  async resendOTP ({ commit }, recipient) {
    const response = await requestOTP(recipient, SMS_PROVIDER).catch((error) =>
      console.error(error)
    )
    if (response) {
      commit('setResentOtp', response.otp)
    }
  },
  async getUserMobileNumber ({ commit }, token) { // TODO use rollbar instead of console to log getNumber error
    const resp = await getNumbers(token).catch(error => console.error(error))

    if (resp) {
      commit('setMobileNumbers', resp)
    }
  }
}

const mutations = {
  resetState: (state) => {
    for (const [key, value] of Object.entries(defaultState)) {
      state[key] = value
    }
  },
  clearOtpInput: (state) => {
    state.otp = ''
  },
  setValid: (state, status) => {
    state.valid = status
  },
  setToken: (state, token) => {
    state.token = token
  },
  setOtp: (state, otp) => {
    state.otp = otp
  },
  setResentOtp: (state, resentOtp) => {
    state.resentOTP = resentOtp
  }
}

export default {
  state: defaultState,
  getters,
  actions,
  mutations
}
